/**
 * Canadian cities data for city-specific search pages.
 *
 * This file re-exports the canonical city data from @paction-2.0/util.
 * The single source of truth is in packages/util/src/constants/geo.ts.
 *
 * Cities included: ~115 cities with population > 30,000
 * Data sources: Statistics Canada, Wikipedia
 *
 * Tier classification:
 * - Tier 1: Top 20 cities by population (static generation priority)
 * - Tier 2: Cities 21-50 by population
 * - Tier 3: Cities 51+ by population (on-demand generation)
 */

// Re-export canonical city data and utilities from util package
export {
  CANADIAN_CITIES as CITIES,
  type City,
  type CityTier,
  getCitiesByProvince,
  getCityBySlug,
  getCitiesByTier,
  getStaticCitySlugs,
  isValidCity,
  formatCityDisplay,
  getProvincesWithCities
} from '@paction-2.0/util';
